import I18n from 'i18n-js';

export default function i18nSetup() {
  window.I18n = I18n;
  I18n.locale = __LOCALE__;
  I18n.defaultLocale = 'fi';
  I18n.translations = I18N_RUNTIME_TRANSLATIONS;
  I18n.placeholder = /%\{(.*?)\}/gm;

  // We want missing placeholders to not output anything in order for the In-Context
  // translation mode to pick the original translation as it was in the language under
  // translation -- that is, we want to effectively disable interpolation altogether.
  if (__LOCALE__ === 'tra') {
    I18n.missingPlaceholder = placeholder => placeholder;
  }
}
